import type { FC } from 'react'
import type { GetUsers_getUsers } from '@g4g/graphql/src/shop/__generated__/GetUsers'
import Link from 'next/link'
import { useRouter } from 'next/router'
import useRecipientUsers from './hooks/useRecipientUsers'
import { PencilSquareIcon } from '@heroicons/react/24/outline'
import RecipientAvatar from './RecipientAvatar'
import { useRecipientOpsDispatch } from './RecipientProvider'

const RecipientChip: FC<{ recipient: GetUsers_getUsers }> = ({ recipient }) => {
  const name = recipient.primaryLogin?.displayName
    ? recipient.primaryLogin.displayName
    : `Guest_${recipient.cosId}`

  return (
    <span title={name} className="max-w-[100px] truncate">
      {name}
    </span>
  )
}

const RecipientEdit: FC = () => {
  const { currentRecipient, loading } = useRecipientUsers()
  const { pathname } = useRouter()
  const dispatch = useRecipientOpsDispatch()

  if (loading) {
    return <div className="lg:bg-white/5 lg:w-[180px] lg:rounded-l-xl"></div>
  }

  return (
    <Link
      href="/recipient"
      onClick={() =>
        dispatch({
          type: 'toggle-checkout-in-progress',
          initiatedCheckout: pathname === '/cart' || pathname === '/checkout',
        })
      }
      className="flex flex-col items-center justify-center lg:px-4 lg:bg-white/5 lg:w-[180px] lg:rounded-l-xl lg:hover:bg-white/10"
    >
      {currentRecipient ? (
        <>
          <div className="hidden text-sm text-white/70 lg:flex">Recipient</div>
          <div className="flex items-center space-x-1 text-white/80 lg:text-white">
            <RecipientAvatar recipient={currentRecipient} small />
            <RecipientChip recipient={currentRecipient} />
            <div className="w-5 h-5">
              <PencilSquareIcon />
            </div>
          </div>
        </>
      ) : (
        <span className="hidden text-white lg:flex">Select recipient</span>
      )}
    </Link>
  )
}

export default RecipientEdit
